import * as $ from 'jquery';

function toggleClass(targetClass, togledClass) {
    
    var els = document.querySelector(targetClass);
    if(els && els.classList.contains(togledClass)) {
        els.classList.remove(togledClass);
    } else if (els){
        els.classList.add(togledClass);
    }
}

const toggleOpenMainSideBar = (e) => {
    let $mobileToggle = $('.mobile-toggle');
    let mobileToggleDisplay = $mobileToggle.css("display")
    if (mobileToggleDisplay !== 'none') {
        toggleClass(".app", 'is-collapsed')
        if (e) {
            e.preventDefault();
        }
    }    
    
    return false;
}

const toggleNotesSideBar = (e) =>{
    toggleClass(".email-app", 'side-active')
    //e.preventDefault();
    return false;
}

export { toggleClass, toggleOpenMainSideBar, toggleNotesSideBar }